/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { useTheme } from '@providers/theme';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { HeroSection, BackArrowComp, TimelineDetailModal } from '../components';
import { vappContainer } from '@/application';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { toHeaderCase } from 'js-convert-case';

import {
  useSMCancelPolicy,
  useSMProvisionalDetailPage,
  useSMTransactionList,
  useSMupdateKycStatus,
  useSMupdatePaymentStatus,
  updateKycStatusMachine,
  updatePaymentStatusMachine,
} from '@pages/ProvisionalDetailPage/machines';
import { ProvisionalDetailPageService } from '@pages/ProvisionalDetailPage/services';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';
import { useLocation } from 'react-router-dom';
import { usePolicyId } from '../provider';

const getSrv = () => {
  return vappContainer.get<ProvisionalDetailPageService>(
    ProvisionalDetailPageService.name
  );
};

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary me-3',
      cancelButton: 'btn btn-secondary',
    },
    buttonsStyling: false,
  })
);

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [cardModal, setCardModal] = useState<boolean>(false);
  const [cardId, setCardId] = useState<string>('');
  const [cancelModal, setCancelModal] = useState<boolean>(false);
  const srv = getSrv();
  const theme = useTheme();
  const { state } = useLocation();

  const { transactionListMachine, transactionListSend, transactionListState } =
    useSMTransactionList({});

  const {
    provisionaldetailPageMachine,
    provisionaldetailPageState,
    provisionaldetailPageSend,
  } = useSMProvisionalDetailPage({});

  const { cancelPolicySend, cancelPolicyState } = useSMCancelPolicy({});

  const { updateKycStatusMachine, updateKycStatusSend, updateKycStatusState } =
    useSMupdateKycStatus({});
  const {
    updatePaymentStatusMachine,
    updatePaymentStatusSend,
    updatePaymentStatusState,
  } = useSMupdatePaymentStatus({});

  const onButtonPress = (key: string) => {
    if (key === 'updatePayment') {
      if (!showModal) {
        setShowModal(true);
      }
    }
    if (key === 'emiOption') {
      toast.success('Coming Soon!');
    }
    if (key === 'cancel') {
      if (!cancelModal) {
        setCancelModal(true);
      }
    }
  };

  const onCardClick = (id: string) => {
    console.log(`card clicked`, id);
    let _cardDetail = srv?.agent?.getFormatTimelineStatus({
      ...transactionListState?.event?.data?.value?.timelineData,
      cardId: id,
    });
    console.log('card detail', _cardDetail);

    if (
      Array.isArray(_cardDetail?.data?.data) &&
      _cardDetail?.data?.data?.length > 0
    ) {
      if (!cardModal) {
        setCardModal(true);
      }
      setCardId(id);
    }
  };

  const onCancelSubmit = (data: any) => {
    if (cancelModal) {
      setCancelModal(!cancelModal);
      cancelPolicySend('START', {
        payload: data,
      });
    }
  };

  const onCardClose = (id: string) => {
    if (cardModal) {
      setCardModal(!cardModal);
    }
  };

  const onRefresh = () => {
    provisionaldetailPageSend('TRIGGER_REFRESH', {});
  };

  const getMatchedNumber = (str: string) => {
    return parseFloat(str.replace(/[^\d\.]*/g, '')).toFixed(2);
  };

  const onPaymentSubmit = async (data: any) => {
    console.log(`payment data`, data);
    const modal = await SwalWithBootstrapButtons.fire({
      title: 'Acknowledgement',
      html: `I acknowledge the receipt of payment ${
        provisionaldetailPageState?.event?.data?.value?.premium
      } on ${data?.instrumentDate} through ${toHeaderCase(
        data?.paymentMethod
      )}`,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Confirm',
    });
    if (modal.isConfirmed) {
      if (showModal) {
        setShowModal(false);
      }
      updatePaymentStatusSend('START', {
        payload: {
          ...data,
          policyId: provisionaldetailPageState?.event?.data?.value?.policyId,
        },
      });
    }
    //update me
    // let countryFound = staticPageContentConfig?.partialPayment["dm"];

    // const formatter = new Intl.NumberFormat(
    //   countryFound?.currencyFormat?.locale,
    //   {
    //     style: "currency",
    //     currency: countryFound?.currencyFormat?.currency,
    //   }
    // );

    // if (data?.amount) {
    //   let premium = getMatchedNumber(
    //     provisionaldetailPageState?.event?.data?.value?.premium
    //   );
    //   let minAmount = premium * (60 / 100);
    //   if (
    //     parseFloat(data?.amount) < minAmount ||
    //     parseFloat(data?.amount) > premium
    //   ) {
    //     const modal = await SwalWithBootstrapButtons.fire({
    //       title: "",
    //       html: `Partial Payment minimum should be ${formatter.format(
    //         minAmount
    //       )} and maximum ${formatter.format(premium)}`,
    //       showCancelButton: false,
    //       confirmButtonText:
    //         staticPageContentConfig?.partialPayment?.confirmButton,
    //     });
    //   } else {
    //     if (showModal) {
    //       setShowModal(false);
    //     }
    //     updatePaymentStatusSend("START", {
    //       payload: {
    //         ...data,
    //         policyId: provisionaldetailPageState?.event?.data?.value?.policyId,
    //       },
    //     });
    //   }
    //   if (showModal) {
    //     setShowModal(false);
    //   }
    // } else {
    //   if (showModal) {
    //     setShowModal(false);
    //   }
    //   updatePaymentStatusSend("START", {
    //     payload: {
    //       ...data,
    //       amount: data?.fullAmount,
    //       policyId: provisionaldetailPageState?.event?.data?.value?.policyId,
    //     },
    //   });
    // }
  };

  const onUpdatePartialPayment = (data: any) => {
    if (updateModal) {
      setUpdateModal(false);
    }
    updatePaymentStatusSend('START', {
      payload: {
        ...data,
        paymentStatus: 'paid',
        policyId: provisionaldetailPageState?.event?.data?.value?.policyId,
      },
    });
  };

  const _renderNotification = () => {
    console.log(
      'update kyc success',
      srv?.agent?.getStaticProvisionalDetailSync()
    );
    if (updateKycStatusState?.matches('UPDATE_KYC_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          title="Kyc Updated"
          description={'Kyc Updated Successfully'}
          // {...(srv?.agent?.getStaticProvisionalDetailSync()?.notifications
          //   ?.updateKycSuccess || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (updatePaymentStatusState?.matches('UPDATE_PAYMENT_STATUS_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getStaticProvisionalDetailSync()?.notifications
            ?.updatePaymentSuccess || {})}
          onAcknowledgement={props?.onGoBack}
          onDeny={onRefresh}
        />
      );
    }
    if (cancelPolicyState?.matches('CANCEL_POLICY_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getStaticProvisionalDetailSync()?.notifications
            ?.cancelSuccess || {})}
          onAcknowledgement={props?.onGoBack}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderProvisionalDetail = () => {
    console.log('render page', provisionaldetailPageState?.event?.data?.value);
    if (updatePaymentStatusState?.matches('UPDATE_PAYMENT_STATUS')) {
      return (
        <StateOSD
          {...(srv?.agent?.getStaticProvisionalDetailSync()?.loading
            ?.paymentStatus || {})}
        />
      );
    }
    if (cancelPolicyState?.matches('CANCEL_POLICY')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingProvisionalDetailSync()?.loading
            ?.cancelLoading || {})}
        />
      );
    }
    // if (state.detail) {
    //   let productDetail = srv?.agent?.getFormatPolicyStatus(state?.detail);
    //   console.log(`transaction detail:`, transactionListState?.event?.data?.value);
    //   console.log(`policyDetail:`, productDetail);
    //   let _tempItems = [...productDetail?.accordionItems]
    //   if(Array.isArray(provisionaldetailPageState?.event?.data?.value?.accordionItems)){
    //     _tempItems = [...provisionaldetailPageState?.event?.data?.value?.accordionItems];
    //   }
    //   if(Array.isArray(transactionListState?.event?.data?.value?.accordionItems)){
    //     _tempItems =[..._tempItems, ...transactionListState?.event?.data?.value?.accordionItems];
    //   }

    //   return (
    //     <>
    //       <HeroSection
    //         {...(productDetail || {})}
    //         {...(provisionaldetailPageState?.event?.data?.value || {})}
    //         accordionItems={_tempItems}
    //         onHeroButtonClick={onButtonPress}
    //         carouselItems={
    //           provisionaldetailPageState?.event?.data?.value?.carouselItems ??
    //           []
    //         }
    //         buttons={provisionaldetailPageState?.event?.data?.value?.buttons}
    //         timelineCardClick={onCardClick}
    //       />
    //     </>
    //   );
    // }
    if (updateKycStatusState?.matches('UPDATE_KYC')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingProvisionalDetailSync()?.loading
            ?.loadingProfile || {})}
        />
      );
    }
    if (
      provisionaldetailPageState?.matches('RENDER_PROVISIONAL_DETAIL_POLICY')
    ) {
      let _tempItems: any = [];
      if (
        Array.isArray(
          provisionaldetailPageState?.event?.data?.value?.accordionItems
        )
      ) {
        _tempItems = [
          ...provisionaldetailPageState?.event?.data?.value?.accordionItems,
        ];
      }
      if (
        Array.isArray(transactionListState?.event?.data?.value?.accordionItems)
      ) {
        _tempItems = [
          ..._tempItems,
          ...transactionListState?.event?.data?.value?.accordionItems,
        ];
      }
      return (
        <>
          <HeroSection
            {...(provisionaldetailPageState?.event?.data?.value?.feature || {})}
            accordionItems={_tempItems}
            onHeroButtonClick={onButtonPress}
            timelineCardClick={onCardClick}
          />
        </>
      );
    }
    if (provisionaldetailPageState?.matches('GET_PROVISIONAL_DETAIL_POLICY')) {
      return (
        <StateOSD
          {...(srv?.agent?.getStaticProvisionalDetailSync()?.loading
            ?.loadingProfile || {})}
        />
      );
    }
    return null;
  };

  const _renderErrorModals = () => {
    if (updatePaymentStatusState?.matches('UPDATE_PAYMENT_STATUS_FAILED')) {
      if (showModal) {
        setShowModal(false);
      }
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorProvisionalDetailContentSync()?.error
            ?.updatePayment || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (
      provisionaldetailPageState?.matches('RENDER_PROVISIONAL_DETAIL_ERROR')
    ) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorProvisionalDetailContentSync()?.error
            ?.getPageContent || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (updateKycStatusState?.matches('UPDATE_KYC_FAILED')) {
      if (updateModal) {
        setUpdateModal(false);
      }
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorProvisionalDetailContentSync()?.error
            ?.updateKyc || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (cancelPolicyState?.matches('CANCEL_POLICY_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorProvisionalDetailContentSync()?.error
            ?.cancelError || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };
  const _renderHeader = () => {
    return <BackArrowComp />;
  };
  const _renderModal = () => {
    if (showModal) {
      return (
        <TweetyModal
          key={`${new Date()}`}
          show={true}
          size={'md'}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Update'}
          onSubmit={onPaymentSubmit}
          onHide={() => setShowModal(false)}
          title={'Update Payment Status'}
          tweetyWidgetProps={{
            fields:
              srv?.agent?.getStaticProvisionalDetailSync()?.updatePayment
                ?.FIELDS,
            layout:
              srv?.agent?.getStaticProvisionalDetailSync()?.updatePayment
                ?.layout,
            dynamicLayout:
              srv?.agent?.getStaticProvisionalDetailSync()?.updatePayment
                ?.dynamicLayout,
            initialData: {
              amount: getMatchedNumber(
                provisionaldetailPageState?.event?.data?.value?.premium
              ),
            },
          }}
        />
      );
    }
    if (updateModal) {
      return (
        <TweetyModal
          key={`${new Date()}`}
          show={true}
          size={'md'}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Update'}
          onSubmit={onUpdatePartialPayment}
          onHide={() => setUpdateModal(false)}
          title={'Collect Full Payment'}
          tweetyWidgetProps={{
            fields:
              srv?.agent?.getStaticProvisionalDetailSync()?.updatepayment
                ?.FIELDS,
            layout:
              srv?.agent?.getStaticProvisionalDetailSync()?.updatepayment
                ?.layout,
            initialData: {
              amount: provisionaldetailPageState?.event?.data?.value?.minDue,
            },
          }}
        />
      );
    }
    if (cardModal) {
      let _temp = srv?.agent?.getFormatTimelineStatus({
        ...transactionListState?.event?.data?.value?.timelineData,
        cardId,
      });
      console.log(`_temp data`, _temp);
      return (
        <TimelineDetailModal
          showModal={cardModal}
          modalTitle={_temp?.title}
          data={_temp?.data}
          onDeny={onCardClose}
        />
      );
    }
    if (cancelModal) {
      return (
        <TweetyModal
          key={`${new Date()}`}
          show={true}
          size={'md'}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Submit Cancellation'}
          onSubmit={onCancelSubmit}
          onHide={() => setCancelModal(false)}
          title={'Cancel Policy'}
          tweetyWidgetProps={{
            fields:
              srv?.agent?.getStaticProvisionalDetailSync()?.cancelPolicy
                ?.FIELDS,
            layout:
              srv?.agent?.getStaticProvisionalDetailSync()?.cancelPolicy
                ?.layout,
          }}
        />
      );
    }
  };

  const _renderPage = () => {
    return (
      <>
        {_renderHeader()}
        {_renderProvisionalDetail()}
        {_renderModal()}
        {_renderErrorModals()}
        {_renderNotification()}
      </>
    );
  };
  return <>{_renderPage()}</>;
};
